import { useTranslation } from 'next-i18next'
import React from 'react'

import ResourceLink from '../../resource-link'
import MediaBox from '../MediaBox'

const GroupRequestRejected = ({ card }) => {
  const { resource } = card
  const target = resource.target

  const { t } = useTranslation('updates')

  return (
    <MediaBox
      card={card}
      target={target}
      customeClass="activity--group activity--group-rejected"
    >
      <ResourceLink className="activity__title" to={target}>
        {target.title}
      </ResourceLink>
      <div className="activity__reason">
        {t('updates.institution_request_rejected')}
      </div>
    </MediaBox>
  )
}

export default GroupRequestRejected
